import React from "react";

import { Plug } from "lucide-react";

import AzureStorageIcon from "../assets/icons/logos/azure-storage.svg?react";
import BoxIcon from "../assets/icons/logos/box.svg?react";
import DropboxIcon from "../assets/icons/logos/drop-box.svg?react";
import EvernoteIcon from "../assets/icons/logos/Evernote.svg?react";
import GmailIcon from "../assets/icons/logos/Gmail.svg?react";
import GoogleDriveIcon from "../assets/icons/logos/google-drive.svg?react";
import TeamsIcon from "../assets/icons/logos/ms-teams.svg?react";
import OneDriveIcon from "../assets/icons/logos/Onedrive.svg?react";
import OneNoteIcon from "../assets/icons/logos/Onenote.svg?react";
import OutlookIcon from "../assets/icons/logos/outlook.svg?react";
import SharePointIcon from "../assets/icons/logos/share-point.svg?react";
import SlackIcon from "../assets/icons/logos/slack.svg?react";
import TelegramIcon from "../assets/icons/logos/telegram.svg?react";
import TwitterIcon from "../assets/icons/logos/twitter.svg?react";
import WhatsAppIcon from "../assets/icons/logos/whatsapp.svg?react";

const SOURCE_ICON_MAP = {
  telegram: TelegramIcon,
  teams: TeamsIcon,
  slack: SlackIcon,
  whatsapp: WhatsAppIcon,
  twitter: TwitterIcon,
  box: BoxIcon,
  onedrive: OneDriveIcon,
  sharepoint: SharePointIcon,
  azure_storage: AzureStorageIcon,
  googledrive: GoogleDriveIcon,
  dropbox: DropboxIcon,
  gmail: GmailIcon,
  outlook: OutlookIcon,
  evernote: EvernoteIcon,
  onenote: OneNoteIcon,
} as const;

type Source = keyof typeof SOURCE_ICON_MAP;

/**
 * Get the appropriate icon component for an integration
 * @param source - The integration source (e.g., 'gmail', 'slack')
 * @param size - The size of the icon (default: 24)
 * @returns React component for the integration icon
 */
export const getIcon = (
  source: string,
  size: number = 24,
): React.ReactElement => {
  // Try to get integration-specific icon first
  if (source in SOURCE_ICON_MAP) {
    const IconComponent = SOURCE_ICON_MAP[
      source as Source
    ] as React.ComponentType<React.SVGProps<SVGSVGElement>>;

    return (
      <IconComponent width={size} height={size} className="fill-current" />
    );
  }

  // Default fallback icon
  return <Plug size={size} />;
};
